import { OrderStopType } from "@/constants/order";
import type { RouteStopDto, TripRouteDto } from "@/api/trips/dto/trip.dto";
import type { TripMonitorRoute } from "@/api/trips/dto/trip-monitor";
import type { TripRouteStop } from "@/types/trip";

export function isRouteTravelOrderInProgress(
  route: TripRouteDto | undefined,
  travelOrderId: number | undefined,
): boolean {
  if (!route || !travelOrderId) {
    return false;
  }

  const nextStop = route.routeStops.find((routeStop) => routeStop.id === route.nextStopId);

  if (nextStop?.travelOrderIds?.length) {
    return nextStop.travelOrderIds.includes(travelOrderId);
  }

  const firstTravelOrderId = [...route.travelOrders].sort((a, b) => (a.id ?? 0) - (b.id ?? 0))[0]?.id;

  return travelOrderId === firstTravelOrderId;
}

export function isMonitorRouteTravelOrderInProgress(route: TripMonitorRoute, travelOrderId: number): boolean {
  const nextStopTravelOrderId = route.nextRouteStop?.travelOrderId;

  if (nextStopTravelOrderId) {
    return travelOrderId === nextStopTravelOrderId;
  }

  const firstTravelOrderId = [...route.travelOrders].sort((a, b) => a.id - b.id)[0]?.id;

  return travelOrderId === firstTravelOrderId;
}

export function getTravelOrderRouteAddress(
  routeStops: (TripRouteStop | RouteStopDto)[],
  travelOrderId: number,
): string | null {
  const travelOrderStops = routeStops
    .filter((routeStop) => !routeStop.isDeleted && routeStop.travelOrderIds?.includes(travelOrderId))
    .sort((a, b) => a.position - b.position);

  const firstPickup = travelOrderStops.find((routeStop) => routeStop.type === OrderStopType.pickup);
  const lastDelivery = travelOrderStops.findLast((routeStop) => routeStop.type === OrderStopType.delivery);

  return formatRouteAddress(firstPickup?.facility?.address, lastDelivery?.facility?.address);
}

export function formatRouteAddress(from?: string | null, to?: string | null): string | null {
  if (!from || !to) {
    return null;
  }

  return `${from} → ${to}`;
}
